import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import camelcaseKeys from 'camelcase-keys';
var socialFeedApi = createApi({
    reducerPath: 'socialFeedApi',
    baseQuery: fetchBaseQuery(),
    endpoints: function (builder) { return ({
        getSocialFeed: builder.query({
            query: function (_a) {
                var url = _a.url, headers = _a.headers;
                return ({
                    url: url,
                    headers: headers,
                });
            },
            transformResponse: function (data) { return camelcaseKeys(data, { deep: true }); },
        }),
    }); },
});
export var socialFeedApiReducer = socialFeedApi.reducer;
export var socialFeedApiMiddleware = socialFeedApi.middleware;
export var useGetSocialFeedQuery = socialFeedApi.useGetSocialFeedQuery;
export default socialFeedApi;
